import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { TranslateService } from '@ngx-translate/core';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermServicesPage } from '../term-services/term-services';
import { RefundPolicyPage } from '../refund-policy/refund-policy';
import { ConfigProvider } from '../../providers/config/config';
import { SurveyDetailPage } from '../survey-detail/survey-detail';
import { LoadingProvider } from '../../providers/loading/loading';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import { Http } from '@angular/http';
import swal from 'sweetalert';
import { AlertProvider } from '../../providers/alert/alert';
import { HomePage } from '../home/home';
import { RelativeTimePipe } from '../../pipes/relative-time/relative-time';

@Component({
  selector: 'view-survey',
  templateUrl: 'view-survey.html',
})
export class ViewSurveyPage {
  orders = new Array;
  loadedorders = new Array;
  httpRunning = true;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: Http,
    public config: ConfigProvider,
    public shared: SharedDataProvider,
    translate: TranslateService,
    public alert: AlertProvider,
    public loading: LoadingProvider
  ) {
  }
  getItems(searchbar){
    // Reset items back to all of the items
    this.initializeItems();
    // set q to the value of the searchbar
    var q = searchbar.srcElement.value;

    // if the value is an empty string don't filter the items
     if (!q) {
       return;
     }

     this.orders = this.orders.filter((v) => {

   if(v.SurName && q) {
     if (v.SurName.toLowerCase().indexOf(q.toLowerCase()) > -1) {
       return true;
     }
     return false;
   }
 });


  };

  initializeItems(): void {
  this.orders = this.loadedorders;
}
  getSurveys() {
    this.httpRunning = true;
    this.orders = [];
    this.loadedorders = [];
    this.loading.show();
    var data: { [k: string]: any } = {};
    data.customers_id = this.shared.customerData.customers_id;
    data.language_id = this.config.langId;
    this.http.post(this.config.url + 'getSurveys', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      this.httpRunning = false;
      //$rootScope.address=response.data.data;
      if (data.success == 1) {
        console.log("Orders:",data);
        this.orders = [];
        this.orders = data.data;
        this.loadedorders = this.orders;
      }
      // $scope.$broadcast('scroll.refreshComplete');
    },
      function (response) {
        this.loading.hide();
        this.alert.show("Server Error while Loading Orders");
        console.log(response);
      });
  };

  showSurveyDetail(order) {
    console.log("Survey Detail:",order);
    this.navCtrl.push(SurveyDetailPage, { 'data': order });

  }
  ionViewDidLoad() {
    this.httpRunning = true;
    this.getSurveys();
  }
  openCart() {
    this.navCtrl.push(CartPage);
  }
  openSearch() {
    this.navCtrl.push(SearchPage);
  }
  openHomePage() {

    this.navCtrl.setRoot(HomePage);

  }
}



// WEBPACK FOOTER //
// ./src/pages/view-survey/view-survey.ts